module.exports = __webpack_public_path__ + "static/media/natwest-gogreen.0888ba80.svg";